import { render, staticRenderFns } from "./fund.vue?vue&type=template&id=63e9ff84&scoped=true&"
import script from "./fund.vue?vue&type=script&lang=ts&"
export * from "./fund.vue?vue&type=script&lang=ts&"
import style0 from "./fund.vue?vue&type=style&index=0&id=63e9ff84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e9ff84",
  null
  
)

export default component.exports